export default "__VITE_PUBLIC_ASSET__5dce1c4a__"